import { connect } from "react-redux";

import Header from "../components/Table.Header.Component";

import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    order: (key, order, tableKey) => {
      dispatch(tableActions.order(key, order, tableKey));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
